import React,{ createContext, useContext, useState, ReactNode } from "react";
import { Socio } from "../types/Socio";

interface SocioContextType {
  socio: Socio | null;
  setSocio: (socio: Socio | null) => void;
}

const SocioContext = createContext<SocioContextType | undefined>(undefined);

export const SocioProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [socio, setSocioState] = useState<Socio | null>(() => {
    try {
      return JSON.parse(localStorage.getItem("socioSeleccionado") || "null");
    } catch {
      return null;
    }
  });

  const setSocio = (nextSocio: Socio | null) => {
    setSocioState(nextSocio);
    if (nextSocio) {
      const clean: Record<string, any> = { ...(nextSocio as any) };
      delete clean.pagos_locales;
      delete clean.sos_sync_status;
      localStorage.setItem("socioSeleccionado", JSON.stringify(clean));
    } else {
      localStorage.removeItem("socioSeleccionado");
    }
  };

  return (
    <SocioContext.Provider value={{ socio, setSocio }}>
      {children}
    </SocioContext.Provider>
  );
};

// Custom hook para utilizar el contexto
export const useSocioContext = () => {
  const context = useContext(SocioContext);
  if (!context) {
    throw new Error("useSocioContext debe usarse dentro de un SocioProvider");
  }
  return context;
};
